import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactHighCharts from 'react-highcharts';
import qs from 'qs';
import chartSelector from 'selectors/indicator/chart';
import tableSelector from 'selectors/indicator/table';
import { infoSelector } from 'selectors/indicator';
import { actionUpdateFilter } from 'actions';
import classNames from 'classnames';
import getViewProperties from 'services/getViewProperties';

// Components
import IndicatorHeader from 'components/indicatorHeader';
import TableRowChart from 'components/tableRowChart';
import table from 'components/table';
import TableControls from 'components/tableControls';
import Copyright from 'components/copyright';
import TextBlock from 'components/textBlock';

// Styles
import styles from './chartView.scss';

const Table = table(TableRowChart);

class ChartView extends Component {
  constructor(props) {
    super(props);
    this.maxSelections = 7;

    const {
      tableFilter,
      updateFilter,
      history,
      pathname,
      search,
    } = props;
    if (this.maxSelections < tableFilter.length) {
      const newFilter = tableFilter.slice(0, this.maxSelections);
      updateFilter(newFilter);
      const query = qs.parse(search, { ignoreQueryPrefix: true });
      history.push({
        pathname,
        search: qs.stringify({
          ...query,
          geos: newFilter.join(','),
        }, {
          encoder: (str) => encodeURIComponent(str).replace(/%2C/g, ','),
        }),
      });
    }
  }

  componentDidUpdate() {
    this.chart.update({ ...this.props.config }, true, true);
  }

  render() {
    const {
      columns,
      config,
      info: {
        shortTitle = '',
        sources = '',
      },
      match: {
        params: {
          renderType = '',
        },
      },
      pathname,
      rowData,
    } = this.props;
    const {
      isEmbedded,
      isExporting,
      isMinimalView,
    } = getViewProperties(renderType);
    return (
      <div>
        <IndicatorHeader />
        <div
          className={classNames(
            styles.section,
            {
              [styles.exporting]: isExporting,
            }
          )}
        >
          {!isMinimalView &&
            <div className={styles.controls}>
              <TableControls />
            </div>
          }
          <h3 className={styles.title}>{shortTitle}</h3>
          <div
            className={styles.chartWrapper}
          >
            <div className={styles.chart}>
              <ReactHighCharts
                config={config}
                callback={(chart) => { this.chart = chart; }}
              />
            </div>
          </div>
          {!isMinimalView &&
            <div className={styles.helpText}>
              <p className={styles.paragraph}>
                Use the checkboxes and filter to customize the table. Reset to
                restore all states. <em>Note</em>: For visual clarity,
                this chart can only account for seven trends.
              </p>
            </div>
          }
          {!isMinimalView &&
            <Table columns={columns} rowData={rowData} />
          }
          {isMinimalView && sources &&
            <TextBlock
              title="Sources"
              text={sources}
            />
          }
          <Copyright
            isEmbedded={isEmbedded}
            isExporting={isExporting}
            originalPath={pathname}
          />
        </div>
      </div>
    );
  }
}

ChartView.propTypes = {
  config: PropTypes.object.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      idx: PropTypes.number.isRequired,
      colId: PropTypes.string.isRequired,
      label: PropTypes.string,
      fixed: PropTypes.oneOf(['left', 'right']),
    })
  ).isRequired,
  rowData: PropTypes.arrayOf(
    PropTypes.shape({
      rowId: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          idx: PropTypes.number.isRequired,
          fixed: PropTypes.oneOf(['left', 'right']),
          align: PropTypes.oneOf(['right', 'center', 'left']),
          formattedValue: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  info: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  tableFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateFilter: PropTypes.func.isRequired,
  history: PropTypes.any.isRequired,
  pathname: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
};

const makeMapStateToProps = (state, ownProps) => ({
  config: chartSelector(state, ownProps),
  info: infoSelector(state),
  tableFilter: state.data.tableFilter,
  history: state.router.history,
  pathname: state.router.location.pathname,
  search: state.router.location.search,
  ...tableSelector(state, { pinValue: 'United States' }),
});

const mapDispatchToProps = (dispatch) => ({
  updateFilter: (geos) => dispatch(actionUpdateFilter(geos, false)),
});

export default connect(
  makeMapStateToProps,
  mapDispatchToProps
)(withRouter(ChartView));



// WEBPACK FOOTER //
// ./app/components/chartView/index.js